/**
 * Outline icon strokes (SVG user units). Keep aligned with admin
 * `teboxDesignSystem.components.icon` in `@boubou/tebox-design-system`.
 */
export const ICON_STROKE = {
  standard: 1.5,
  hairline: 1,
  emphasis: 2,
  /** Golf cart SVG — same as admin `components.icon.strokeGolfCart`. */
  golfCart: 2,
} as const;
